enum PaymentRemittancesNameType {
  TRADE = 'TRADE',
  CORPORATE = 'CORPORATE',
}

export default PaymentRemittancesNameType;
